import type { CappusError } from '../error/cappus-error';
import type { CappusErrorHandler } from '../cappus-error-handler';
import { HttpStatusCode } from '@angular/common/http';
import { AuthService } from '../../../auth/auth.service';
import { inject } from '@angular/core';
import { openErrorToast } from '@pct/ng-feature-message';

export class UnauthorizedErrorHandler implements CappusErrorHandler {
  private readonly authService = inject(AuthService);

  canHandle(err: CappusError): boolean {
    return err.status === HttpStatusCode.Unauthorized;
  }

  handle(): Promise<void> {
    openErrorToast({ message: `API_ERRORS.UNAUTHORIZED` });
    return this.authService.logout();
  }
}
